<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro de Alimentos">
    <form ref="form" @submit.prevent="submitForm">
      <div v-for="field in fields" :key="field.key" class="row">
        <div v-if="field.type === 'select'" class="col-md-6">
          <label :for="field.key">{{ field.label }}</label
          ><label v-if="field.required" style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <select v-model="registro[field.key]" class="form-select form-input-component" required>
            <option v-for="option in field.options" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div v-else class="col-md-8">
          <label :for="field.key">{{ field.label }}</label
          ><label v-if="field.required" style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <input v-model="registro[field.key]" :type="field.type" class="form-control form-input-component" required />
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { createAlimento, getAlimentoById } from '@/components/service/alimentoService';

export default {
  name: 'FormManterAlimento',
  setup() {
    return {};
  },
  data() {
    return {
      registro: {},
      fields: [
        { key: 'nome', label: 'Descrição', type: 'text', required: true },
        {
          key: 'situacao',
          label: 'Status',
          type: 'select',
          required: true,
          options: [
            { label: 'Ativo', value: 'ATIVO' },
            { label: 'Inativo', value: 'INATIVO' },
          ],
        },
      ],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity()) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else {
        await createAlimento(this.registro).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.registro = {};
          this.submitted = true;
        });
      }
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregarAlimento() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getAlimentoById(idUrl);
        this.registro = { ...res.data, id: idUrl };
      }
    },
  },

  created() {
    this.carregarAlimento();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
